import { mcn } from 'common/funcs/mcn.func';
import { HTMLAttributes } from 'react';

import styles from './BaseContainer.module.scss';

type PropsType = {
  className?: string;
  children: React.ReactNode;
} & HTMLAttributes<HTMLDivElement>;

const BaseContainer = ({ className = '', children, ...rest }: PropsType) => {
  return (
    <div className={mcn([styles.BaseContainer, className])} {...rest}>
      {children}
    </div>
  );
};

export default BaseContainer;
